// <!-- GRACE:MODULE_START name="ui_config" -->
// <!-- GRACE:DEPENDENCY target="ui_config" -->
// Конфигурация API endpoints
import { CURRENT_CONFIG } from './environments';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || CURRENT_CONFIG.API_BASE_URL;

export const API_ENDPOINTS = {
  // Auth endpoints
  AUTH: {
    REGISTER: `${API_BASE_URL}/api/auth/register`,
    LOGIN: `${API_BASE_URL}/api/auth/login`,
    ME: `${API_BASE_URL}/api/auth/me`,
    CHANGE_PASSWORD: `${API_BASE_URL}/api/auth/change-password`,
    FORGOT_PASSWORD: `${API_BASE_URL}/api/auth/forgot-password`,
    RESET_PASSWORD: `${API_BASE_URL}/api/auth/reset-password`,
    LOGOUT: `${API_BASE_URL}/api/auth/logout`,
  },

  // SpeechKit endpoints
  SPEECHKIT: {
    STATUS: `${API_BASE_URL}/api/speechkit/status`,
    UPLOAD: `${API_BASE_URL}/api/speechkit/upload`,
    RECOGNIZE: `${API_BASE_URL}/api/speechkit/recognize`,
    RECOGNIZE_ASYNC: `${API_BASE_URL}/api/speechkit/recognize/async`,
    OPERATION_STATUS: (operationId: string) =>
      `${API_BASE_URL}/api/speechkit/status/${operationId}`,
    LANGUAGES: `${API_BASE_URL}/api/speechkit/languages`,
  },
  
  // GPT endpoints
  GPT: {
    EXTRACT_FACTS: `${API_BASE_URL}/api/gpt/extract-facts`,
    EXTRACT_FACTS_STREAM: `${API_BASE_URL}/api/gpt/extract-facts-stream`,
  },
  
  // Templates endpoints
  TEMPLATES: {
    LIST: `${API_BASE_URL}/api/templates/`,
    FORMAT: `${API_BASE_URL}/api/templates/format`,
  },
  
  // Health check
  HEALTH: `${API_BASE_URL}/health`,
} as const;

export default API_ENDPOINTS;

// <!-- GRACE:MODULE_END name="ui_config" -->
